export const experience = [
  {
    company: 'Bioworld Merchandising',
    roles: [
      { role: 'Associate Designer', period: 'May 2024 — Present' },
    ],
    logo: '/experience/bioworld.svg',
    url: 'https://www.bioworldmerch.com'
  },
  {
    company: 'Dallas College',
    roles: [{ role: 'Experience Design/User Interface (UX/UI) A.A.S.', period: 'Aug 2023 — May 2025' }],
    logo: '/experience/dallas-college.svg',
    url: 'https://www.dallascollege.edu'
  },
  {
    company: 'University of Texas, Arlington',
    roles: [{ role: 'Medical Technology', period: 'Aug 2021 — May 2022' }],
    logo: '/experience/uta.svg',
    url: 'https://www.uta.edu'
  },
  {
    company: 'California State University, Los Angeles',
    roles: [{ role: 'Natural Science', period: 'Aug 2017 — May 2020' }],
    logo: '/experience/csula.svg',
    url: 'https://www.calstatela.edu'
  },
];
